module.exports = __webpack_public_path__ + "static/media/checked.9b39e97d.svg";